module.exports = __webpack_public_path__ + "static/media/me_2.dcd0634f.gif";